






































import { defineComponent, toRefs, PropType, computed, watch, getCurrentInstance, ref } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { i18n } from './../../../i18n';
import BehaviorHashtag from './index';
import Container from '@/components/common/behavior-container/index.vue';
import { useBehaviorData } from './../../../hooks/creation/adgroup/useBehavior/index';
import { StateEnum, useStore, useAdgroupAlertInfo } from '@tt4b/ttam-hooks';

const name = 'ttam-behavior-hashtag-compose';
export default defineComponent({
  name,
  components: {
    Container,
    TtamBehaviorHashtagCategory: BehaviorHashtag.TtamBehaviorHashtagCategory,
    TtamBehaviorHashtagPreofflineHashtagAlert: BehaviorHashtag.TtamBehaviorHashtagPreofflineHashtagAlert,
    TtamBehaviorHashtagOfflineHashtagAlert: BehaviorHashtag.TtamBehaviorHashtagOfflineHashtagAlert,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { campaignData, adgroupData } = toRefs(props);
    const { state } = useStore();
    const hashtagBehaviorMap = computed(() => state[StateEnum.targetInfo].value.hashtagBehaviorMap ?? []);
    const { visible } = BehaviorHashtag.usePropsVisible({
      campaignData,
      adgroupData,
    });
    const { offlineHashTags } = BehaviorHashtag.usePropsOfflineHashtags({
      hashTags: hashtagBehaviorMap as any,
    });
    const { preofflineHashTags } = BehaviorHashtag.usePropsPreofflineHashtags({
      hashTags: hashtagBehaviorMap as any,
    });
    const { hashtagCategories, hashtagData, getChangedBehaviorData, getClearDataByType } = useBehaviorData({
      adgroupData,
    });
    const { title, desc, contentVisible, hasOperated } = BehaviorHashtag.useContainerProps({
      adgroupData,
    });

    const selectedCategories = computed({
      get: () => hashtagCategories.value,
      set: val => {
        const data = getChangedBehaviorData(
          {
            ...hashtagData.value,
            categories: val,
          },
          'hashtag',
        );
        emit('change', data);
      },
    });

    const preofflineAlertVisible = computed(() => preofflineHashTags.value.length > 0);

    const offlineAlertVisible = computed(() => offlineHashTags.value.length > 0);

    const offlineHashTagsVisible = ref(false);
    const onRemoveAll = () => {
      const clearData = getClearDataByType('hashtag');
      emit('change', clearData);
    };

    const { addAlertInfo } = useAdgroupAlertInfo();
    const createElement = getCurrentInstance()?.proxy.$createElement;

    function removeAllOfflineTags() {
      const offlineTagsSet = new Set(offlineHashTags.value.map(e => e.id));
      selectedCategories.value = selectedCategories.value.filter(id => !offlineTagsSet.has(id));

      if (createElement) {
        addAlertInfo({
          key: 'behavior-hashtag',
          message: {
            label: i18n.t('module_adgroup_behavior_behavior_label'),
            content: createElement('i18n', { attrs: { path: 'adgroup_target_hashtag_auto_remove_hint' } }, [
              createElement('a', {
                on: {
                  click: () => {
                    offlineHashTagsVisible.value = true;
                  },
                },
                attrs: { place: 'button' },
                domProps: {
                  innerHTML: i18n.t('adgroup_target_hashtag_auto_remove_hint_button', {
                    num: offlineHashTags.value.length,
                  }),
                },
              }),
            ]),
          },
        });
      }
    }

    const removePreOffline = tags => {
      const hashtagsToRemove = new Set(tags.map(e => e.id));
      selectedCategories.value = selectedCategories.value.filter(id => !hashtagsToRemove.has(id));
    };

    watch(
      offlineHashTags,
      () => {
        if (offlineHashTags.value.length) {
          removeAllOfflineTags();
        }
      },
      {
        immediate: true,
      },
    );

    return {
      name,
      contentVisible,
      title,
      desc,
      hasOperated,
      selectedCategories,
      preofflineHashTags,
      offlineHashTags,
      hashtagBehaviorMap,
      preofflineAlertVisible,
      offlineAlertVisible,
      visible,
      onRemoveAll,
      removePreOffline,
    };
  },
});
